module.exports = {"hero":{"title":"Media","subtitle":"See what we are up to! Whether it's launching a new product or volunteering in the community, our media page has it all."},"all-articles":"All articles","articles":"Articles"}


//////////////////
// WEBPACK FOOTER
// ./src/translations/en/media-articles.json
// module id = Ygpx
// module chunks = 0